<template>
  <main>
    <Transition name="fade">
      <Loader v-if="!$page || !$beet.isReady" />
    </Transition>
    <template v-if="$page && $beet.isReady">
      <Banner :content="bannerContent" />
      <CTASection :content="ctaSection1" />
      <CTASection :content="ctaSection2" class="--reverse" />
      <CTASection :content="ctaSection3" />
      <CTASection :content="ctaSection4" class="--reverse" />
      <QuestionSection />
    </template>
  </main>
</template>

<script>
import Banner from '@/components/sections/Banner.vue'
import CTASection from '@/components/sections/CTASection.vue'
import QuestionSection from '@/components/sections/QuestionSection.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin'

export default {
  mixins: [PageMetaMixin],
  name: 'Hotel',
  beetPage: 'hotel',
  components: { Banner, CTASection, Loader, QuestionSection },
  computed: {
    bannerContent() {
      return {
        image: this.$page.header.image,
        subtitle: this.$page.header.subtitle,
        title: this.$page.header.title,
      }
    },
    ctaSection1() {
      return {
        button: this.$page.about.button_label,
        image: this.$page.about.image,
        link: this.$beet.options.contact.reservation_url,
        titleBlock: {
          description: this.$page.about.content,
          subtitle: this.$page.about.title,
          title: this.$page.about.label,
        },
      }
    },
    ctaSection2() {
      return {
        button: this.$page.localisation.button_label,
        image: this.$page.localisation.image,
        link: this.isFr
          ? 'https://www.quebec-cite.com/fr/vieux-quebec'
          : 'https://www.quebec-cite.com/en/old-quebec-city',
        titleBlock: {
          description: this.$page.localisation.content,
          subtitle: this.$page.localisation.title,
          title: this.$page.localisation.label,
        },
      }
    },
    ctaSection3() {
      return {
        image: this.$page.history.image,
        titleBlock: {
          description: this.$page.history.content,
          subtitle: this.$page.history.title,
          title: this.$page.history.label,
        },
      }
    },
    ctaSection4() {
      return {
        button: this.$page.services.button_label,
        image: this.$page.services.image,
        route: { name: 'services' },
        titleBlock: {
          description: this.$page.services.content,
          subtitle: this.$page.services.title,
          title: this.$page.services.label,
        },
      }
    },
    isFr() {
      return this.$i18n.locale === 'fr'
    },
  },
}
</script>
